module.exports = __webpack_public_path__ + "static/img/111.15b85fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/111.png
// module id = wij9
// module chunks = 4